import { render, staticRenderFns } from "./cuponItem.vue?vue&type=template&id=06a4f62f&scoped=true&"
import script from "./cuponItem.vue?vue&type=script&lang=js&"
export * from "./cuponItem.vue?vue&type=script&lang=js&"
import style0 from "./cuponItem.vue?vue&type=style&index=0&id=06a4f62f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a4f62f",
  null
  
)

export default component.exports